import { Link } from "react-router-dom";
import vikramshilaLogo from "../../assets/img/logos/aakashganga-logos-Final.svg";
import "./Logo.scss";

export default function Logo() {
  return (
    <>
      <div className="logo_container">
        <Link to="/">
          <img src={vikramshilaLogo} alt="Aakashganga Logo" />
        </Link>
      </div>
    </>
  );
}
